import { render, staticRenderFns } from "./OrderCostBasics.vue?vue&type=template&id=7113dba8"
import script from "./OrderCostBasics.vue?vue&type=script&lang=js"
export * from "./OrderCostBasics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports